import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, finalize, map, of, switchMap, tap } from 'rxjs';
import { WizardStepActions } from '../../actions/generations/generation-step.actions';
import ScreenInterimActions from '../../actions/generations/screen-interim.actions';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { ApiConstants } from 'src/app/base/api-constants';

@Injectable()
export class WizardStepEffects {
  private readonly actions = inject(Actions);
  private readonly httpService = inject(HttpBaseService);
  private readonly loaderService: AppLoaderService = inject(AppLoaderService);

  navigateWizardStep$ = createEffect(() =>
    this.actions.pipe(
      ofType(WizardStepActions.navigateWizardStep),
      tap(() => {
        this.loaderService.show();
      }),
      switchMap((action: any) => {
        const { apiConstants, urlPathVariables } = action;
        return this.httpService[apiConstants.method](apiConstants, urlPathVariables).pipe(
          map((response: any) => WizardStepActions.setWizardStepSuccess()),
          catchError((error) => of(WizardStepActions.setWizardStepFailure({ error }))),
          finalize(() => {
            this.loaderService.hide();
          })
        );
      })
    )
  );

  generateWizardStep$ = createEffect(() =>
    this.actions.pipe(
      ofType(WizardStepActions.generateWizardStep),
      switchMap((action: any) => {
        const { apiConstants, payloadWithPathVariables } = action;
        return this.httpService[apiConstants.method](apiConstants, payloadWithPathVariables).pipe(
          map(() => WizardStepActions.generateWizardStepSuccess({ generationId: payloadWithPathVariables.generationId })),
          catchError((error) => {
            console.error('generateWizardStep failed:', error);
            return of(WizardStepActions.setWizardStepFailure({ error }));
          })
        );
      })
    )
  );

  refreshScreensInterimOnGenerateSuccess$ = createEffect(() =>
    this.actions.pipe(
      ofType(WizardStepActions.generateWizardStepSuccess),
      map((action) =>
        ScreenInterimActions.getScreensInterim({
          getScreensInterimApiConstants: ApiConstants.getAllScreensInterim,
          payloadWithPathVariables: {
            generationId: action.generationId,
            start: 0,
            length: 10000,
            order: [],
            removeUrlVariables: ['generationId']
          }
        })
      )
    )
  );
}
